<template>
   <modal :options="dopts" @confirm="$emit('confirm')" @close="$emit('close')">
      <p class="confirmer__message" v-text="message"></p>
   </modal>
</template>

<script>
   import Modal from '../../components/common/dialog/dialog.vue';
   import store from '../../store';

   export default {
      name: 'Confirmer',
      store,
      components: { Modal },
      data() {
         return {
            dopts: { showHeader : false, closeOnBackdrop: false },
            message: ''
         };
      },
      mounted() {
         this.message = this.$options.message;
      }
   };
</script>

<style lang="less">
   .confirmer__message {
      padding: .5rem .25rem;
      margin: 0;
      min-height: 5rem;
   }
</style>
